import axiosClient from "../api/axiosClient";

const apiService = {
  get: (endpoint, params = {}, config = {}) =>
    axiosClient.get(endpoint, { params, ...config }),
  post: (endpoint, payload, config = {}) =>
    axiosClient.post(endpoint, payload, config),
  put: (endpoint, payload, config = {}) =>
    axiosClient.put(endpoint, payload, config),
  delete: (endpoint, params = {}, config = {}) =>
    axiosClient.delete(endpoint, { params, ...config }),
};

export default apiService;
